<script>

    import {createEventDispatcher, onMount} from "svelte";
    import DocViewer from "./DocViewer.svelte";
    import Common from "../Common";

    const dispatch = createEventDispatcher();

    let docViewer;
    let displayPDF = false;

    export let rent;

    onMount(async () => {
        jQuery(window).scroll(function (ev) {
            if (ev.currentTarget.pageYOffset > 500) {
                jQuery("#fixedBack").removeClass("hidden");
            } else {
                jQuery("#fixedBack").addClass("hidden");
            }
        });
    });

    function back() {
        dispatch('back', {});
    }

    function showAgreement() {
        docViewer.setup(Common.BASE_API + "order/agreement/" + rent.uuid);
        displayPDF = true;
    }

    function showRentDocument(docDTO) {
        docViewer.setup(Common.BASE_API + "order/rentdocument/" + rent.uuid + "/" + docDTO.uuid);
        displayPDF = true;
    }

    function showDocuments() {
        displayPDF = false;
    }
</script>

<main class="flex flex-row w-full flex-wrap drogowskazFont h-full justify-evenly" class:hidden={displayPDF}>

    <div class="flex flex-row w-full">
        <div class="h-full  w-2/4  flex flex-col bg-white text-center justify-center">
            <div>
                <br/>
            </div>
            <div>
                <img src="/logo.png"/>
            </div>
            <div>
                <br/>
            </div>
        </div>
        <div class="h-full w-2/4 flex flex-col bg-blue-1  text-center justify-center" on:click={back}>
            <div>
                <span class="text-2xl md:text-3xl"><i class="fas fa-arrow-left blue-3 mr-4"></i>Wstecz</span>
            </div>
        </div>
    </div>

    <div class="flex flex-row w-full  white text-white  text-base text-center justify-center py-4 bg-blue-2"
         on:click={showAgreement}>
        <div class="w-1/4 text-center flex flex-col justify-center items-center">
            <i class="far fa-file-alt fa-3x blue-3"></i>
        </div>
        <div class="w-3/4 text-center justify-center flex flex-col">
            <span class="text-3xl mt-4">Umowa</span>
        </div>
    </div>

    {#each rent.documents as doc, i}
        <div class="flex flex-row w-full  white text-white  text-base text-center justify-center py-4"
             class:bg-blue-2="{i%2 === 1}"
             class:bg-blue-3="{i%2 === 0}"
             on:click={() => showRentDocument(doc)}>
            <div class="w-1/4 text-center flex flex-col justify-center items-center">
                <i class="far fa-file-alt fa-3x"
                   class:blue-3="{i%2 === 1}"
                   class:blue-2="{i%2 === 0}"
                ></i>
            </div>
            <div class="w-3/4 text-center justify-center flex flex-col">
                <span class="text-3xl mt-4">{doc.description}</span>
            </div>
        </div>

    {/each}

    <!--{doc}-->
    <!--    //bg-blue-2-->
    <!--    //bg-blue-3-->

</main>


<main class="flex flex-row w-full flex-wrap drogowskazFont h-full justify-evenly" class:hidden={!displayPDF}>
    <div class="flex flex-row w-full">
        <div class="h-full  w-2/4  flex flex-col bg-white text-center justify-center">
            <div>
                <br/>
            </div>
            <div>
                <img src="/logo.png"/>
            </div>
            <div>
                <br/>
            </div>
        </div>
        <div class="h-full w-2/4 flex flex-col bg-blue-1  text-center justify-center" on:click={showDocuments}>
            <div>
                <span class="text-2xl md:text-3xl"><i class="fas fa-arrow-left blue-3 mr-4"></i>Wstecz</span>
            </div>
        </div>
    </div>

    <DocViewer bind:this={docViewer}></DocViewer>

    <div style="    position: fixed;right: 0px;bottom: 0px;width: 33%;background-color: white;
    text-align: center;min-height: 130px;padding-top: 40px;border: 1px solid black;" class="hidden" id="fixedBack"
         on:click={showDocuments}>
        <span class="text-2xl md:text-3xl"><i class="fas fa-arrow-left blue-3 mr-4"></i>Wstecz</span>
    </div>
</main>


